module.exports = __webpack_public_path__ + "static/other/intro_scene.08f64aff.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/intro_scene.json
// module id = 855
// module chunks = 0